export const OTP_CREDENTIAL_ERROR_CODES = {
	abortError: "AbortError",
};
